function blobToImage(blob) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(img.src);
      resolve(img);
    };
    img.onerror = (err) => {
      URL.revokeObjectURL(img.src);
      reject(err);
    };
    img.src = URL.createObjectURL(blob);
  });
}

function canvasToBlob(canvas) {
  if (canvas.toBlob) {
    return new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
  }
  return Promise.resolve(
    (function fallback() {
      const dataUrl = canvas.toDataURL('image/png');
      const byteString = atob(dataUrl.split(',')[1]);
      const len = byteString.length;
      const arrayBuffer = new ArrayBuffer(len);
      const intArray = new Uint8Array(arrayBuffer);
      for (let i = 0; i < len; i += 1) {
        intArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([intArray], { type: 'image/png' });
    })()
  );
}

export async function preprocessImageToBlob(file, scale = 1.8, threshold = 170) {
  const image = await blobToImage(file);
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.floor(image.naturalWidth * scale || image.width * scale));
  canvas.height = Math.max(1, Math.floor(image.naturalHeight * scale || image.height * scale));
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D context is not available');

  ctx.imageSmoothingEnabled = true;
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const { data } = imageData;
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    const gray = Math.round(r * 0.299 + g * 0.587 + b * 0.114);
    const bin = gray > threshold ? 255 : 0;
    data[i] = bin;
    data[i + 1] = bin;
    data[i + 2] = bin;
  }
  ctx.putImageData(imageData, 0, 0);

  const blob = await canvasToBlob(canvas);
  return blob;
}
